import { Box, useTheme } from '@mui/material';
import React, { FC, PropsWithChildren } from 'react';

const AttributeList: FC<PropsWithChildren> = ({ children }) => {
  const theme = useTheme();

  return (
    <Box
      component="table"
      sx={{
        '& a': {
          '&:hover': {
            textDecoration: 'underline',
          },
          display: 'block',
          fontWeight: 'normal',
          textDecoration: 'underline',
        },
        '& label': {
          color: theme.palette.grey.midDark,
        },
        '& td': {
          padding: '.3em 0',
        },
        '& th': {
          color: theme.palette.grey.midDark,
          fontWeight: 600,
          paddingRight: '1rem',
          textAlign: 'left',
        },
        '&:not($fullLabel)': {
          th: {
            width: '30%',
          },
        },
        marginBottom: '.6rem',
      }}
    >
      <tbody>{children}</tbody>
    </Box>
  );
};

export default AttributeList;
